import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {
  FaAward, FaGlobe, FaRocket, FaHandshake, FaBolt,
  FaUserPlus, FaMoneyBill, FaCalendarCheck,
  FaUsers, FaExchangeAlt, FaLock,
} from 'react-icons/fa';

const activeBadges = [
  {
    id: 'starter',
    icon: <FaRocket size={20} />,
    title: 'Starter Spark',
    description: 'Completed first transaction',
    color: 'bg-gradient-to-b from-blue-600 via-indigo-700 to-indigo-800',
  },
  {
    id: 'frequent',
    icon: <FaGlobe size={20} />,
    title: 'Frequent Flyer',
    description: 'Sent to 3+ countries',
    color: 'bg-gradient-to-b from-blue-600 via-indigo-700 to-indigo-800',
  },
  {
    id: 'power',
    icon: <FaBolt size={20} />,
    title: 'Power Transactor',
    description: '$1,000+ monthly volume',
    color: 'bg-gradient-to-b from-blue-600 via-indigo-700 to-indigo-800',
  },
  {
    id: 'trusted',
    icon: <FaHandshake size={20} />,
    title: 'Peer Trust',
    description: 'Trusted by 10+ users',
    color: 'bg-gradient-to-b from-blue-600 via-indigo-700 to-indigo-800',
  },
  {
    id: 'legend',
    icon: <FaAward size={20} />,
    title: 'Verified Legend',
    description: 'Fully verified user with high trust',
    color: 'bg-gradient-to-b from-blue-600 via-indigo-700 to-indigo-800',
  },
];

const inactiveBadges = [
  { id: 'ambassador', icon: <FaUserPlus />, title: 'Wire24 Ambassador' },
  { id: 'highroller', icon: <FaMoneyBill />, title: 'High Roller' },
  { id: 'weekendwarrior', icon: <FaCalendarCheck />, title: 'Weekend Warrior' },
  { id: 'connectmaster', icon: <FaUsers />, title: 'Connect Master' },
  { id: 'currencychamp', icon: <FaExchangeAlt />, title: 'Currency Champion' },
  { id: 'lockedbadge', icon: <FaLock />, title: 'Encrypted Elite' },
];

export const BadgeGroup = () => {
  const [hovered, setHovered] = useState(null);

  return (
    <div className="relative min-h-[100px]">
      {/* BADGES DISPLAY */}
      <AnimatePresence>
        {!hovered && (
          <motion.div
            key="badges"
            className="flex items-center gap-3 flex-wrap"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.4, type: 'tween' }}
          >
            {[...activeBadges, ...inactiveBadges].map((badge) => {
              const isActive = activeBadges.some(b => b.id === badge.id);
              return (
                <motion.div
                  key={badge.id}
                  onMouseEnter={() => isActive && setHovered(badge.id)}
                  className={`w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-white text-xs shadow-lg cursor-pointer
                    ${isActive ? activeBadges.find(b => b.id === badge.id).color : 'bg-black/60 text-white/30 grayscale'}`}
                >
                  {badge.icon}
                </motion.div>
              );
            })}
          </motion.div>
        )}
      </AnimatePresence>

      {/* TEXT DISPLAY ON HOVER */}
      <AnimatePresence>
        {hovered && (
          <motion.div
            key="hover-details"
            className="absolute inset-0 flex flex-col justify-center items-start px-4 py-3 rounded-xl border border-white/10 bg-white/5 backdrop-blur-md shadow-lg"
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -100 }}
            onMouseLeave={() => setHovered(null)}
            transition={{ duration: 0.4, type: 'tween' }}
          >
            <div className="flex items-center gap-3 mb-2">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center text-white ${activeBadges.find(b => b.id === hovered)?.color}`}
              >
                {activeBadges.find(b => b.id === hovered)?.icon}
              </div>
              <h4 className="text-base font-semibold text-white">
                {activeBadges.find(b => b.id === hovered)?.title}
              </h4>
            </div>
            <p className="text-white/60 text-sm">
              {activeBadges.find(b => b.id === hovered)?.description}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
